import { defineComponent as _defineComponent } from 'vue'
import { useMediaAsset } from '~/composables';
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFeaturesBanner',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

return { __sfc: true,getAssetUrl, CdnImg, handleImageSrc, handleImageAlt }
}

})